/**
 * Row selection on the log file import list, which selects across pages: `selected` holds every
 * ticked id, `pageIds` the ids on the page being shown.
 */
export const pageSelectionState = (selected: number[], pageIds: number[]) => ({
    allSelected: pageIds.every(id => selected.includes(id)),
    someSelected: pageIds.some(id => selected.includes(id)),
});

/** The header checkbox: untick this page's rows if they're all ticked, otherwise tick them all. */
export const togglePageSelection = (
    selected: number[],
    pageIds: number[],
    allSelected: boolean,
): number[] =>
    allSelected
        ? selected.filter(id => !pageIds.includes(id))
        : [...new Set([...selected, ...pageIds])];

type LogFileBulkAction = 'reprocess' | 'delete' | 'ignore';

/** "Apply" needs at least one ticked import and a chosen action. */
export const canApplyBulkAction = (
    selected: number[],
    action: LogFileBulkAction | '' | null,
): action is LogFileBulkAction => selected.length > 0 && action != null && action !== '';
